let site_icon_path = 'site_logo.png';
let site_logo_path = 'site_logo.png';
let site_title = 'eta_car1nae';
let code_for_sketch_icon_text = '</>';
let code_for_sketch_text = 'Code for this Sketch';
let instagram_icon_src = 'icon-instagram.svg';
let instagram_text = 'Instagram';
let github_icon_dark_src = 'icon-github.svg';
let github_icon_light_src = 'icon-github-white.svg';
let github_text = 'GitHub';
let copyright_symbol = '©';
let copyright_text = '<urit_gupta/>';

let instagram_url = 'https://www.instagram.com/eta_car1nae';
let github_url = 'https://www.github.com/urit-gupta';
let github_repo_url = 'https://www.github.com/urit-gupta/portfolio';
let site_url = 'https://urit-gupta.github.io/portfolio';

let sketchUrls = [];
let sketchTitles = [];
let sketchSubtitles = [];
let sketchDescriptions = [];
let currentSketchIndex = 0;

let callID = 0;
let flaggedCIDs = [];
let hashSketchTitles = [];

let csvData = '';

function initSiteContents() {
  document.getElementById('site-icon').setAttribute('href', site_icon_path);
  document.getElementById('site-logo').setAttribute('src', site_logo_path);
  document.getElementById('site-logo-button').setAttribute('href', site_url);
  document.getElementById('site-title-button').setAttribute('href', site_url);
  document.getElementById('site-title').textContent = site_title;

  document.getElementById('code-for-sketch-icon').textContent =
    code_for_sketch_icon_text;
  document.getElementById('code-for-sketch-text').textContent =
    code_for_sketch_text;

  document
    .getElementById('instagram-icon')
    .setAttribute('src', instagram_icon_src);
  document.getElementById('instagram-text').textContent = instagram_text;

  document
    .getElementById('github-icon')
    .setAttribute('src', github_icon_light_src);
  document.getElementById('github-text').textContent = github_text;

  document.getElementById('copyright-icon').textContent = copyright_symbol;
  document.getElementById('copyright-text').textContent = copyright_text;

  document
    .getElementById('instagram-button')
    .setAttribute('href', instagram_url);
  document.getElementById('github-button').setAttribute('href', github_url);
  document
    .getElementById('copyright-button')
    .setAttribute('href', github_repo_url);
}

async function readCsv() {
  let response = await fetch('sketchData.csv');
  csvData = await response.text();

  const csvLines = csvData.split('\n');
  const headerRow = csvLines[0].split(',');
  for (let i = 1; i < csvLines.length; i++) {
    const fields = csvLines[i].split(',');
    if (fields[0].length < 4) {
      break;
    }
    if (fields.length === headerRow.length) {
      sketchTitles.push(fields[1].trim());
      hashSketchTitles.push(fields[1].split(' ').join(''))
      sketchSubtitles.push(fields[2].trim());
      sketchDescriptions.push(fields[3].trim());
    }
    if (fields.length > 0) {
      sketchUrls.push(fields[0].trim());
    }
  }

  if (window.location.hash == '' && sketchUrls.length > 0) {
    currentSketchIndex = Math.floor(Math.random() * sketchUrls.length);
  } else {
    sketchFromHash();
  }

  if (currentSketchIndex >= 0) {
    updateSketchFrameAndHash();
  }
}

document.onkeydown = function (e) {
  if (e.key == 'ArrowRight' || e.key == 'ArrowUp') {
    nextSketch();
  } else if (e.key == 'ArrowLeft' || e.key == 'ArrowDown') {
    prevSketch();
  }
};

window.addEventListener('hashchange',() =>{
  sketchFromHash();
});

function sketchFromHash() {
  currentSketchIndex = hashSketchTitles.indexOf(window.location.hash.slice(1));
}

function prevSketch() {
  currentSketchIndex =
    (currentSketchIndex - 1 + sketchUrls.length) % sketchUrls.length;
    updateSketchFrameAndHash();
}

function nextSketch() {
  currentSketchIndex = (currentSketchIndex + 1) % sketchUrls.length;
  updateSketchFrameAndHash();
}

function updateSketchFrameAndHash() {
  callID++;
  const iframe = document.getElementById('sketch-iframe');
  iframe.setAttribute('src', sketchUrls[currentSketchIndex]);

  document
    .getElementById('code-for-sketch-button')
    .setAttribute(
      'href',
      sketchUrls[currentSketchIndex].replace('full', 'sketches')
    );
  window.location.hash = hashSketchTitles[currentSketchIndex];

  displaySketchInfo(callID);
}

function displaySketchInfo(cID) {
  if (document.querySelector('.sketch_info').style.visibility == 'hidden') {
    showSketchInfoContainer(cID);
  }

  setTimeout(() => {
    displaySketchValue(cID);
  }, 1000);
}

function displayCursorBlink(cID, id, end_flag=false) {
  for (let o = 1; o <= 2; o++) {
    setTimeout(() => {
      changeText(id, document.getElementById(id).textContent + '|', cID);
      setTimeout(() => {
        changeText(id, document.getElementById(id).textContent.replace('|', ''), cID);
        if (o == 2 && !end_flag) {
          setTimeout(() => {
            displaySketchValue(cID, id);
          }, 250);
        }
      }, 150);
    }, 500 * o);
  }
}

function displaySketchValue(cID, id='sketch-title') {
  let next_id = '';
  let currentString = '';
  let ind = 0;
  let t_string = '';

  switch(id) {
    case 'sketch-title':
      currentString = sketchTitles[currentSketchIndex];
      next_id = 'sketch-subtitle';
      break;
    case 'sketch-subtitle':
      currentString = sketchSubtitles[currentSketchIndex];
      next_id = 'sketch-description';
      break;
    case 'sketch-description':
      currentString = sketchDescriptions[currentSketchIndex];
      next_id = 'end';
      break;
  }

  for (let i = 0; i < currentString.length; i++) {
    setTimeout(() => {
      changeText(id, t_string + '|', cID);
      setTimeout(() => {
        ind++;
        t_string = currentString.slice(0, ind+1);
        changeText(id, t_string + '|', cID);
        if (i == currentString.length - 1) {
          changeText(id, t_string, cID);
          setTimeout(() => {
            displayCursorBlink(cID, id, true);
          }, 0);
          if (next_id == 'end') {
            setTimeout(() => {
              hideSketchInfo(cID);
            }, 12000);
          } else {
            setTimeout(() => {
              displayCursorBlink(cID, next_id);
            }, 1400);
          }
        }
      }, 120);
    }, 120 * i);
  }
}

function hideSketchInfo(cID) {
  setTimeout(() => {
    hideSketchValue(cID);
  }, 1000);
}

function hideSketchValue(cID, id='sketch-description') {
  let next_id = '';
  let currentString = '';

  switch(id) {
    case 'sketch-description':
      currentString = sketchDescriptions[currentSketchIndex];
      next_id = 'sketch-subtitle';
      break;
    case 'sketch-subtitle':
      currentString = sketchSubtitles[currentSketchIndex];
      next_id = 'sketch-title';
      break;
    case 'sketch-title':
      currentString = sketchTitles[currentSketchIndex];
      next_id = 'end';
      break;
  }

  changeText(id, document.getElementById(id).textContent + '|', cID);
  for (let i = 0; i < currentString.length; i++) {
    setTimeout(() => {
      changeText(id, document.getElementById(id).textContent.slice(0, -2) + '|', cID);
      if (i == currentString.length - 1) {
        changeText(id, '', cID);
        if (next_id == 'end') {
          setTimeout(() => {
            hideSketchInfoContainer(cID);
          }, 100);
        } else {
          hideSketchValue(cID, next_id);
        }
      }
    }, 60 * i);
  }
}

function hideSketchInfoContainer(cID) {
  if (callID == cID) {
    document.querySelector('.sketch_info').style.visibility = 'hidden';
  }
}

function showSketchInfoContainer(cID) {
  changeText('sketch-title', '', cID);
  changeText('sketch-subtitle', '', cID);
  changeText('sketch-description', '', cID);
  document.querySelector('.sketch_info').style.visibility = 'visible';
}

function changeText(id, textContent, cID) {
  if (callID != cID) {
    if (flaggedCIDs.indexOf(cID) < 0) {
      flaggedCIDs.push(cID);
      document.getElementById(id).textContent =
        document.getElementById(id).textContent.replace('|', '');
    }
    return;
  }
  document.getElementById(id).textContent = textContent;
}

initSiteContents();
readCsv();
